import React from "react";
import { categories } from "../mock";

export default function CategoriesMarquee() {
  const list = [...categories, ...categories];
  return (
    <div className="fixed bottom-0 left-0 right-0 z-30 bg-black/90 backdrop-blur-md border-t border-white/10 py-2 overflow-hidden">
      <div className="marquee-track">
        {list.map((c, i) => (
          <span key={i} className="inline-flex items-center gap-1 px-4 text-xs text-white/65 hover:text-red-500 transition cursor-pointer whitespace-nowrap">
            <span>{c.name}</span>
            <span className="text-red-500 font-semibold">({c.count})</span>
            <span className="text-red-500">*</span>
          </span>
        ))}
      </div>
    </div>
  );
}
